export default "__VITE_ASSET__066e469a__"